import { Controller } from "@hotwired/stimulus";

// Frame navigation does not reset document scrolling like a full-page visit.
export default class extends Controller<HTMLElement> {
  static targets = ["focus"];
  static values = { anchorOnly: Boolean };
  declare readonly hasFocusTarget: boolean;
  declare readonly focusTarget: HTMLElement;
  declare readonly anchorOnlyValue: boolean;
  private task?: number;

  connect() {
    this.task = requestAnimationFrame(() => {
      // Fetch redirects discard fragments, so balance confirmation uses a query key.
      const account = this.anchorOnlyValue ? new URL(window.location.href).searchParams.get("account") : null;
      const anchor = document.getElementById(account ? `accounts-card-${account}` : window.location.hash.slice(1));
      if (anchor && this.element.contains(anchor)) {
        anchor.tabIndex = -1;
        anchor.focus({ preventScroll: true });
        anchor.scrollIntoView({ block: "center", behavior: "instant" });
      } else if (!this.anchorOnlyValue) {
        if (this.hasFocusTarget) this.focusTarget.focus({ preventScroll: true });
        window.scrollTo({ top: 0, behavior: "instant" });
      }
    });
  }

  disconnect() {
    if (this.task !== undefined) cancelAnimationFrame(this.task);
  }
}
